import {lazy} from "react";

export const ReportGroupMileageLazy = lazy(()=>import('./ReportGroupMileage'))